@if (showTopBtns$ | async) {
	<div class="text-right mb-2">
		<button class="btn-link pr-3" translate="Actions.CreateCompany" data-cy="CreateCompany" type="button" (click)="createNewCompany()"></button>
		@if (canCreateFederation$ | async) {
			<button class="btn-link " translate="Actions.CreateFederation" data-cy="CreateFederation" type="button" (click)="createNewFederation()"></button>
		}
	</div>
}

@if (pendingFederations$ | async; as pending) {
	<div class="content-block has-padding" [class.block-loader]="loader.isLoading$ | async">
		<loader-spinner [model]="loader"/>
		<loader-spinner [model]="loaderUser"/>
	
		<ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onTabChange($event)">
			@if (subsidiaries$ | async; as subsidiaries) {
				<li ngbNavItem="subsidiaries" [class.hidden]="(subsidiaries.length === 0 && pending.none)">
					<a ngbNavLink translate="PageTitles.SubsidiariesTab" data-cy="SubsidiariesTab"></a>
					<ng-template ngbNavContent>
						@if (subsidiaries$ | async; as subsidiaries) {
							<div class="mt-4 mb-4">
								@if (subsidiaries.length === 0 && (loader.isLoading$ | async) === false && pending.none) {
									<ngb-alert type="info" [dismissible]="false">
										{{ 'Subsidiaries.NoSubsidiary' | translate }}
									</ngb-alert>
								}
			
								@if (pending.some) {
									<ngb-alert type="info" [dismissible]="false">
										{{ 'Subsidiaries.PendingItems' | translate }}
									</ngb-alert>
								}
			
								<subsidiaries-list
									[hasPendingSubsidiaries]="hasPendingSubsidiaries$ |async"
									[subsidiaries]="subsidiaries"
								/>
							</div>
						}
					</ng-template>
				</li>
			}
	
			@if (federations$ | async; as federations) {
				<li ngbNavItem="federations" [class.hidden]="((federations.length === 0) && pending.none)">
					<a ngbNavLink translate="PageTitles.FederationsTab" data-cy="FederationsTab"></a>
					<ng-template ngbNavContent>
						<div class="mt-4 mb-4">
							@if (federations.length === 0 && (loader.isLoading$ | async) === false && pending.none) {
								<ngb-alert
									translate="Federation.List.NoFederations"
									[dismissible]="false"
									type="info">
								</ngb-alert>
							}
		
							@if (pending.some) {
								<ngb-alert
									translate="Federation.List.PendingItems"
									[dismissible]="false"
									type="info">
								</ngb-alert>
							}
		
							<federations-list [hasPendingFederations]="pending.some" [federations]="federations"/>
						</div>
					</ng-template>
				</li>
			}
		</ul>
	
		<div [ngbNavOutlet]="nav"></div>
	
		<div class="buttons-list d-none d-sm-block">
			<div class="text-center">
				@if (user$ | async; as user) {
					@if (!user.isSupport) {
						<button class="btn btn-link" translate="Actions.EditMyInformations" data-cy="EditMyInformations" (click)="editMyInformations()"></button>
					}
				}
				<button class="btn btn-link " translate="Actions.CreateCompany" data-cy="CreateCompany" type="button" (click)="createNewCompany()"></button>
				@if (canCreateFederation$ | async) {
					<button class="btn btn-link " translate="Actions.CreateFederation" data-cy="CreateFederation" type="button" (click)="createNewFederation()"></button>
				}
			</div>
		</div>
	</div>
}
